import React from "react";

import FILTVOverlayInfo from "./FILTVOverlayInfo";
import FILTVTVFrame from "./FILTVTVFrame";
import FILTVMerchantBadge from "./FILTVMerchantBadge";
import FILTVChannelTransition from "./FILTVChannelTransition";
import FILTVPlayer from "./FILTVPlayer";

const FILTVVideoPlayer = ({ channel, ad, transition, loading }) => {
    return (
        <div className="relative">
            <FILTVTVFrame>
                <FILTVPlayer ad={ad} channel={channel} loading={loading} />
                {ad && <FILTVOverlayInfo channel={channel} ad={ad} />}
                {ad && <FILTVMerchantBadge ad={ad} />}

                <FILTVChannelTransition visible={transition} channel={channel} />
            </FILTVTVFrame>
        </div>
    );
};

export default FILTVVideoPlayer;
